import { render, staticRenderFns } from "./AdvancedOptions.vue?vue&type=template&id=95048cde&scoped=true"
import script from "./AdvancedOptions.vue?vue&type=script&lang=js"
export * from "./AdvancedOptions.vue?vue&type=script&lang=js"
import style0 from "./AdvancedOptions.vue?vue&type=style&index=0&id=95048cde&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95048cde",
  null
  
)

export default component.exports